<!-- 新增编辑页面 -->
<template>
    <div class="addbox">
    <el-card :body-style="{ padding: '10px 50px' }">
      <el-form
        :label-position="labelPosition"
        label-width="80px"
        :model="formLabelAlign"
      >
        <el-form-item label="粉丝昵称">
          <el-input v-model="formLabelAlign.nickname"></el-input>
        </el-form-item>
        <el-form-item label="打赏数">
          <el-input v-model="formLabelAlign.reward"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="postmsg">保存</el-button>
          <el-button @click="hideadd">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  props:{
        hideadd:{
            type:Function,
            default:null
        },
        addcommit:{
            type:Function,
            default:null
        },
        
    },
  data () {
    return {
      labelPosition: "left",
      formLabelAlign: {
        nickname: "",
        reward: ""
      },
    };
  },

  components: {},
  methods: {
    postmsg(){
      this.formLabelAlign["reward"] = parseInt(this.formLabelAlign["reward"])
      this.addcommit(this.formLabelAlign)
    }
  }
}

</script>
<style lang='scss' scoped>
.addbox {
  width: 500px;
}
</style>